import assert from 'minimalistic-assert';
import { UnsupportedWalletAccountSource } from './errors.js';
const MODULE_ID = 'transactionSigner';
class TransactionSigner {
    #seedBasedTransactionSigner;
    #hardwareWallets;
    constructor({ hardwareWallets, seedBasedTransactionSigner }) {
        this.#seedBasedTransactionSigner = seedBasedTransactionSigner;
        this.#hardwareWallets = hardwareWallets;
    }
    #getTransactionSigner = async (walletAccount) => {
        if (walletAccount.isSoftware) {
            return this.#seedBasedTransactionSigner;
        }
        if (walletAccount.isHardware && this.#hardwareWallets) {
            return this.#hardwareWallets.requireDeviceFor(walletAccount);
        }
        throw new UnsupportedWalletAccountSource(walletAccount.source);
    };
    signTransaction = async (opts) => {
        assert(typeof opts === 'object', `signTransaction expected parameters`);
        const { baseAssetName, unsignedTx, walletAccount } = opts;
        assert(typeof baseAssetName === 'string', `baseAssetName must be string`);
        assert(typeof unsignedTx === 'object', `unsignedTx must be object`);
        const { txData, txMeta } = unsignedTx;
        assert(typeof txData === 'object' && txData !== null, `txData must be object`);
        assert(typeof txMeta === 'object' && txMeta !== null, `txMeta must be object`);
        const signer = await this.#getTransactionSigner(walletAccount);
        return signer.signTransaction({
            baseAssetName,
            unsignedTx,
            walletAccount,
        });
    };
}
const createTransactionSigner = (opts) => new TransactionSigner(opts);
const transactionSignerDefinition = {
    id: MODULE_ID,
    type: 'module',
    factory: createTransactionSigner,
    dependencies: ['seedBasedTransactionSigner', 'hardwareWallets?'],
    public: true,
};
export default transactionSignerDefinition;
